<template>
    <site-img
        class="md-form layout6 mg-bg"
        type="bgImg"
        :src="bgType === 'img' ? useBgSrc : ''"
        :style="{
            ...spaceStyle,
            ...colorStyle,
            background: formBgColor
        }"
    >
        <div class="md-form-container">
            <div
                class="info-agent-box"
                :style="{
                    background: bgColor
                }"
            >
                <div
                    class="info-agent f-col"
                    v-if="agent && (agent.firstName || agent.lastName)"
                    :style="{
                        background: bgColor
                    }"
                >
                    <AgentHeadShot class="agent-image" :headshots="agent.headShots" :initImage="agent.image" keyClass="md-form-layout6" />
                    <div
                        class="agent-detail"
                        :style="{
                            background: agentBgColor
                        }"
                    >
                        <site-title
                            v-if="agentTitle"
                            :title="agentTitle"
                            align="left"
                        />

                        <div class="agent-content">
                            <div v-if="agent.phone" class="contact phone">
                                <p class="title">
                                    {{ $t('md-form.phone') }}
                                </p>
                                <p class="content">
                                    <a
                                        :href="'tel:' + agent.phone"
                                        target="_top"
                                        rel="noopener noreferrer"
                                    >
                                        <span>{{
                                            $ft.formatPhone(agent.phone)
                                        }}</span>
                                    </a>
                                </p>
                            </div>
                            <div v-if="agent.email" class="contact email">
                                <p class="title">
                                    {{ $t('md-form.emailV6') }}
                                </p>
                                <p class="content">
                                    <a
                                        :href="'mailTo:' + agent.email"
                                        rel="noopener noreferrer"
                                    >
                                        <span>{{ agent.email }}</span>
                                    </a>
                                </p>
                            </div>
                            <div
                                v-if="agent.address && agent.address !== ' '"
                                class="contact address"
                            >
                                <p class="title">
                                    {{ $t('md-form.address') }}
                                </p>
                                <p class="content">
                                    <a
                                        target="_blank"
                                        :href="
                                            'https://www.google.com.my/maps/search/' +
                                                agent.address
                                        "
                                        v-text="agent.address"
                                        rel="noopener noreferrer"
                                    ></a>
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="info-form f-col">
                <site-title
                    v-if="touchTitle"
                    :title="touchTitle"
                    align="center"
                />

                <info-form-v2
                    :registerRole="registerRole"
                    :tag="tag"
                    :questionnaire="questionnaire"
                    :onSubmitOption="onSubmitOption"
                    :formList="formList"
                    :showTitle="false"
                    :lenderStyle="lenderStyle"
                    :defaultMsg="defaultMsg"
                    :submitText="submitOptionText"
                    :submitStyle="{
                        backgroundColor: submitBgColor,
                    }"
                    :messageOutside="true"
                    :registerLogin="registerLogin"
                    submitPos="afterbottom"
                    @done="handleShowToast"
                    :disclaimerColor="colorMap?.text || '#a0a3af'"
                />
            </div>

            <form-toast
                v-model:visible="formToastVisible"
                v-bind="formToastOption"
                @confirm="handleToastConfirm"
            />
        </div>
    </site-img>
</template>

<script>
import common from '../index';
import infoFormV2 from '../info-form-v2.vue';
import formToast from '@/components/form-toast';

export default {
    mixins: [common],
    data() {
        return {};
    },
    components: {
        infoFormV2,
        formToast
    }
};
</script>

<style lang="scss">
@import '../../../theme/media.scss';
@import '../../../theme/mixin.scss';
.md-form.layout6 {
    .site-title {
        font-weight: 700;
        
    }

    .md-form-container {
        position: relative;
    }

    .info-agent-box {
        height: 232px;
        margin-bottom: 238px;
    }
    .info-agent {
        height: 380px;
        padding: 50px;
        position: absolute;
        top: 30px;
        left: 0;
        right: 0;
        display: flex;
        .agent-image {
            width: 280px;
            aspect-ratio: 1;
            .img-content {
                position: static;
            }
        }
        .agent-detail {
            flex: 1;
            display: flex;
            flex-direction: column;
            justify-content: center;
            gap: 60px;
            padding: 40px;
            .site-title {
                color: var(--g-primary-color);
                text-align: left;
            }

            .agent-content {
                display: flex;
                justify-content: space-between;
                column-gap: 20px;

                .contact {
                    .title {
                        font-size: 14px;
                        font-weight: 400;
                        line-height: 21px;
                        text-align: left;
                        margin-bottom: 16px;
                        color: var(--g-text-color);
                    }
                    .content {
                        font-size: 16px;
                        font-weight: 500;
                        line-height: 24px;
                        text-align: left;
                        color: var(--g-primary-color);
                        position: relative;
                        text-decoration: none;
                        transition: .3s ease;
                        &:before,
                        &:after {
                            content: "";
                            display: block;
                            width: 0;
                            height: 1px;
                            background: var(--g-primary-color);
                            position: absolute;
                            left: 0;
                            bottom: 0;
                            transition: .3s ease;
                        }
                        &:before {
                            width: 100%;
                            opacity: 0.5;
                        }
                        &:hover:after {
                            width: 100%;
                        }
                    }
                }
            }
        }
    }

    .info-form {
        .info-form2 {
            margin-top: 40px;
            .input-content {
                display: flex;
                column-gap: 20px;
                .basic-info {
                    display: flex;
                    flex-wrap: wrap;
                    row-gap: 30px;
                    width: calc((100% - 20px) / 2);
                    .basic-info-input {
                        width: 100%;
                        input {
                            width: 100%;
                            height: 60px;
                            box-shadow: none;
                            padding: 20px 15px;
                            background: transparent;
                            font-size: 16px;
                            font-weight: 400;
                            line-height: 19.5px;
                            text-align: left;
                            &:focus {
                                border-color: var(--g-btn-background);
                            }
                        }
                        &.firstName {
                            width: calc(50% - 10px);
                            @include media-800 {
                                width: 100%;
                            }
                        }
                        &.lastName {
                            width: calc(50% - 10px);
                            margin-left: 20px;
                            @include media-800 {
                                width: 100%;
                                margin-left: 0px;
                            }
                        }
                    }

                    .chime-datepicker {
                        input {
                            padding-left: 35px;
                            border-radius: 0;
                        }
                        .date-picker-input-wrapper i.iconfont {
                            top: 10px;
                        }
                    }
                }
                .v-input.message {
                    width: calc((100% - 20px) / 2);

                    .input-container {
                        height: 100%;

                        // &::-webkit-scrollbar {
                        //     width: 6px;
                        // }
                        // &::-webkit-scrollbar-track {
                        //     background: transparent;
                        //     border-radius: 6px;
                        // }
                        // &::-webkit-scrollbar-thumb {
                        //     border-radius: 6px;
                        //     position: relative;
                        //     display: block;
                        //     width: 0;
                        //     height: 0;
                        //     cursor: pointer;
                        //     background-color: rgba(144, 147, 153, 0.3);
                        //     -webkit-transition: 0.3s background-color;
                        //     transition: 0.3s background-color;
                        // }
                    }
                    textarea {
                        width: 100%;
                        height: 100%;
                        box-shadow: none;
                        padding: 15px;
                        background: transparent;
                        font-size: 16px;
                        font-weight: 400;
                        line-height: 19.5px;
                        text-align: left;
                        &:focus {
                            border-color: var(--g-btn-background);
                        }
                    }
                }
                .v-input {
                    &[class*='paragraphText'] {
                        textarea {
                            width: 100%;
                            height: 112px;
                            padding: 15px;
                            background: transparent;
                            font-size: 16px;
                            font-weight: 400;
                            line-height: 19.5px;
                            text-align: left;
                            box-shadow: none;
                        }
                    }
                }
            }
            .submit-content {
                text-align: right;
                margin-top: 40px;
                .submit {
                    min-width: 200px;
                    padding: 20px 40px;
                    height: 60px;
                    font-size: 16px;
                    font-weight: 400;
                }
            }
        }
        .v-input .input-container .label-top {
            display: none;
        }

        .disclaimer-wrap.opt-in {
            margin-top: 10px;
            color: var(--g-tip-color);
            .checkbox-li .check-box-container {
                border: 1px solid var(--g-tip-color);
            }
            .disclaimer-content {
                color: var(--g-tip-color);
            }
            .privacy-text {
                color: var(--g-tip-color);
                margin-top: 10px;
            }
        }
        // .disclaimer-wrap.opt-in .privacy-text::before {
        //     content: none;
        // }
    }

    @include media-800 {
        .md-form-container {
            position: static;
        }
        .info-agent-box {
            padding-top: 40px;
            padding-bottom: 20px;
            height: auto;
            position: static;
            margin-bottom: 0;
        }
        .info-agent {
            display: block;
            height: auto;
            padding: 0;
            position: static;
            .agent-image {
                width: 100%;
            }
            .img-box {
                width: 100%;
            }
            .agent-detail {
                padding: 20px;
                gap: 20px;
                .agent-content {
                    flex-direction: column;
                    row-gap: 20px;

                    .contact {
                        .title {
                            margin-bottom: 10px;
                        }
                        .content {
                            display: inline-block;
                        }
                    }
                }
            }
        }
        .info-form {
            padding-top: 20px;

            .info-form2 {
                margin-top: 20px;
                .input-content {
                    flex-direction: column;
                    row-gap: 20px;
                    .basic-info {
                        row-gap: 20px;
                        width: 100%;
                        .basic-info-input {
                            width: 100%;
                            input {
                                height: 50px;
                                padding: 15px;
                            }
                            &.firstName,
                            &.lastName {
                                width: 100%;
                            }
                        }
                        .chime-datepicker {
                            input {
                                padding-left: 35px;
                                border-radius: 0;
                            }
                            .date-picker-input-wrapper i.iconfont {
                                top: 5px;
                            }
                        }
                    }
                    .v-input.message {
                        width: 100%;
                        height: 150px;
                        textarea {
                            padding: 10px 15px;
                        }
                    }
                }
                .submit-content {
                    margin-top: 20px;
                    .submit-box {
                        width: 100%;
                    }
                    .submit {
                        width: 100%;
                        height: 50px;
                        padding: 15px 20px;
                    }
                }
            }

            .disclaimer-wrap.opt-in {
                margin-top: 0;
            }
        }
    }
}
</style>
